// Images for the freelance income potential page
export const freelanceImage1 = "/assets/jpg/freelance1.jpg";
export const freelanceImage2 = "/assets/jpg/freelance2.jpg";
export const freelanceImage3 = "/assets/jpg/freelance3.jpg";
export const freelanceImage4 = "/assets/jpg/freelance4.jpg";
export const freelanceImage5 = "/assets/jpg/freelance5.jpg";
export const freelanceImage6 = "/assets/jpg/freelance6.jpg";

// Footer CTA image
export const freelanceCTAImage = "/assets/jpg/freelance-cta.jpg";
